import React from 'react';
import {
  Button,
  ButtonColor,
  ButtonSize,
  IconType,
  useShowContextRequired
} from 'ui-builder';
import { AbstractTask, TaskPermission } from 'nekst-api';
import useDeleteTaskPopupManager from '../projects/view/tasks/list/DeleteTaskPopup';

export default function DeleteTaskButton() {

  const deletePopupManager = useDeleteTaskPopupManager();

  const showContext = useShowContextRequired<AbstractTask>();

  if (showContext.data.permissions.includes(TaskPermission.DELETE)) {
    return (
      <Button
        text="Delete"
        color={ButtonColor.RED}
        size={ButtonSize.MEDIUM}
        iconType={IconType.TRASH}
        onClick={async () => {
          await deletePopupManager.openPopup(
            showContext.data!.id,
            showContext.data!.name,
          );
        }}
      />
    );
  } else {
    return null;
  }
}
